import React from "react";
import { List, Typography } from "antd";
import "./notification.css";
import { useTranslation } from "react-i18next";


const { Text } = Typography;

const NotificationList = ({ notifications, onNotificationClick }) => {
   const {t} = useTranslation('common');
  return (
    <div className="notification-list">
          <List
            header={<Text strong>{t("notification")}</Text>}
            dataSource={notifications}
            locale={{ emptyText: t("all_caught_up") }}  // ← here
            renderItem={(notification) => (
              <List.Item className="notification-list-item">
                <Text>{notification.messageText}</Text>{" "}
                {notification.type === "report" && (
                  <Text
                    className="notification-view-report"
                    onClick={() =>onNotificationClick(notification)}
                  >
                    {t("view_report")}
                  </Text>
                )}
                {notification.type === "pdf_upload" && (
                  <Text
                    className="notification-view-report"
                    onClick={() =>onNotificationClick(notification)}
                  >
                    {t("download")}
                  </Text>
                )}
              </List.Item>
            )}
          />
        </div>
  );
};

export default NotificationList;
